// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestinationSettingsHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import { observer } from 'mobx-react';
import localizer from 'share/localization/Izenda.Localizer';

function SourceDestinationSettingsHeader({
  item,
  icon,
  title,
  collapseToggle,
  style,
  className,
  showCopyPositionId
}: {
  item: any,
  icon: string,
  title: string,
  collapseToggle: Function,
  style: any,
  className: string,
  showCopyPositionId: boolean
}): any {
  const onCopyPositionIdCheck = function(e: any): void {
    item.setCopyPositionId(e.target.checked);
  };

  return (
    <div className='u-posRelative'>
      <strong onClick={collapseToggle} style={style} className={className}>
        {icon ? <i className={icon} /> : null}
        {title}
      </strong>
      {showCopyPositionId && (
        <div className='u-posAbsolute u-posAbsoluteCenter'>
          <label className='u_noMarginBottom'>
            <input
              type='checkbox'
              checked={item.copyPositionId}
              onChange={onCopyPositionIdCheck}
              className='u_noMarginTop u_alignMiddle'
            />
            <span className='u_paddingRight u_alignMiddle u_textNormal u_inlineBlock'>{localizer.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_COPY_RELATIONSHIP_POSITION_ID')}</span>
          </label>
        </div>
      )}
    </div>
  );
}

export default observer(SourceDestinationSettingsHeader);



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/Izenda.SourceDestinationSettingsHeader.js